<template>
  <Form style="line-height:32px"
        ref="formdata"
        :model="formdata"
        :label-width="120"
        inline>
    <FormItem :label="$t('erp.b2c.activation_type',{defaultValue:'激活类型'})"
              style="width:90%"
              :rules="required"
              prop="activetype">
      <Select v-model="formdata.activetype"
              filterable>
        <Option v-for="item in alltypes"
                :value="item.value"
                :key="item.value">{{item.title}}</Option>
      </Select>
    </FormItem>
    <FormItem :label="$t('erp.b2c.activation_reason',{defaultValue:'激活原因'})"
              style="width:90%"
              :rules="required"
              prop="activeremark">
      <Input v-model="formdata.activeremark"
             :rows="3"
             type="textarea" />
    </FormItem>
    <footer class="text-right">
      <Button type="primary"
              @click="submit">{{$t('global.common.update_submit',{defaultValue:'提交'})}}</Button>
      <Button class="margin-left-10"
              @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Button>
    </footer>
    <Spin size="large"
          fix
          v-if="loading"></Spin>
  </Form>
</template>
<script>
import { HttpActiveOrder } from '@/service/boss/b2corder'
import { mapState } from 'vuex'
export default {
  props: ['activeids'],
  data () {
    return {
      loading: false,
      show: true,

      alltypes: [
        { value: 0, title: this.$t('erp.b2c.choose_shipallpros', { defaultValue: '激活订单，发货所有产品' }) },
        { value: 1, title: this.$t('erp.b2c.choose_shipdeleverablepros', { defaultValue: '激活订单，发货可发货产品' }) },
        { value: 2, title: this.$t('erp.b2c.choose_notshiporder', { defaultValue: '置为不发货订单' }) },
      ],
      formdata: {
        activeremark: '',
        activetype: "",
      },
      required: [{
        required: true,
        message: this.$t("global.common.fill_requiredd", { defaultValue: '该信息不能为空,请填写' })
      }],
    }
  },
  methods: {
    cancel () {
      this.$emit('on-close')
    },
    async submit () {
      let bool = await this.$refs['formdata'].validate();
      if (!bool) return;
      this.loading = true;
      HttpActiveOrder({
        node: this.formdata.activetype,
        orderIds: this.activeids,
        remark: this.formdata.activeremark,
      }).then(res => {
        this.$Message.success(res.message);
        this.cancel();
        this.$emit('on-update');
      }, err => {
        this.$VMessage.error({
          content: err.message,
          duration: 30,
          closable: true
        });
      }).finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>

